module.exports = __webpack_public_path__ + "img/icon382.4bd1b11d.png";